// Hand-rolled mirror of @zencity/ebuilder-types image-crop.schema.json (ENG-4178).
// EPF intentionally does NOT depend on that package, so this shape is duplicated here
// and the golden-fixture test in imageBossUrl.spec.ts is the drift fence between the two.
// A missing imageCrop means serve full-frame (backward-compatible: existing published
// images already have the crop baked into the stored URL).

// Natural pixel dimensions the rect was authored against (imageCrop.source).
export interface ImageCropSource {
  width: number;
  height: number;
}

// Normalized 0-1 crop rect (imageCrop.crops.<key>.rect). Authoritative for the URL.
export interface ImageCropRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

// A single crop entry. Only `rect` drives the URL; the rest are editor-reconstruction
// fields that never appear in the rendered ImageBoss URL.
export interface ImageCropEntry {
  rect: ImageCropRect;
  aspectRatio?: number;
  ratioKey?: string;
  mode?: 'auto' | 'manual';
  focalCenter?: { x: number; y: number };
}

// The `default` breakpoint key the MVP writes. The `crops` map is open so breakpoint
// keys (tablet/mobile/laptop/desktop) can be added later without a shape change.
export const DEFAULT_CROP_KEY = 'default';

export interface ImageCrop {
  version: number;
  source: ImageCropSource;
  crops: Record<string, ImageCropEntry>;
  focalSynced?: boolean;
  minHeight?: number;
  objectPosition?: Record<string, { x: number; y: number }>;
}
